import * as net from 'util/Net';

export function fetchForSequence(data) {
  return net.postJSON({url: '/1/api/hr-template-designs/actions/check-exists', data});
}

export function create(data) {
  return net.postJSON({url: '/1/api/hr-template-designs/', data});
}

export function update(sequenceId, data) {
  return net.patchJSON({url: `/1/api/hr-template-designs/${sequenceId}`, data});
}
